exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* Expnad */\n.h-300 {\n  height: 300px;\n  overflow: hidden;\n}\n\nbutton.btn-more {\n  display: inline-block;\n  position: relative;\n  z-index:1;\n  border: none;\n  padding: 1rem 2rem;\n  margin: 0;\n  text-decoration: none;\n  background: #ffffff;\n  color: #777;        \n  cursor: pointer;\n  text-align: center;\n  transition: background 250ms ease-in-out, \n              transform 150ms ease;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\nbutton.btn-more:hover,\nbutton.btn-more:focus {\n  color: #003366;\n}\n\nbutton.btn-more:focus {\n  outline: 1px solid #fff;\n  outline-offset: -4px;\n}\n\nhr {\n  width: 100%;\n  position: absolute;\n  bottom: 16px;\n  z-index: 0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/js/components/expand/expand.css
// module id = 34
// module chunks = 1